import React, { useState } from "react";
import { jsPDF } from "jspdf";
import { FileDown, LoaderCircle } from "lucide-react";

export const ShoppingListButton = ({ state, result }) => {
  const [busy, setBusy] = useState(false);

  const download = () => {
    if (busy) return;
    setBusy(true);
    try {
      const doc = new jsPDF({ unit: "pt", format: "letter" });
      const W = doc.internal.pageSize.getWidth();
      doc.setFillColor(11, 9, 8);
      doc.rect(0, 0, W, 118, "F");
      doc.setTextColor(212, 155, 75);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text("P O P   S O C I A L   E V E N T S", 48, 46);
      doc.setTextColor(250, 247, 242);
      doc.setFont("times", "normal");
      doc.setFontSize(26);
      doc.text("Spirit Shopping List", 48, 82);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(156, 143, 128);
      doc.text(`${state.guestCount} guests  ·  ${state.durationHours} active hours  ·  ${result.totalDrinks} estimated drinks`, 48, 102);

      let y = 156;
      doc.setTextColor(60, 50, 40);
      const line = (label, value, bold = false) => {
        doc.setFont("helvetica", bold ? "bold" : "normal");
        doc.setFontSize(12);
        doc.setTextColor(40, 34, 28);
        doc.text(label, 48, y);
        doc.text(value, W - 48, y, { align: "right" });
        doc.setDrawColor(222, 210, 192);
        doc.line(48, y + 9, W - 48, y + 9);
        y += 30;
      };
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor(212, 155, 75);
      doc.text("SPIRITS", 48, y - 8);
      y += 12;
      result.spiritBottles.forEach((spirit) => line(`${spirit.label}${spirit.weight > 1 ? `  (weighted x${spirit.weight})` : ""}`, `${spirit.bottles} x 750ml bottle${spirit.bottles > 1 ? "s" : ""}`));
      y += 8;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.setTextColor(212, 155, 75);
      doc.text("WINE & BEER", 48, y - 8);
      y += 12;
      line("Wine", `${result.wineBottles} x 750ml bottle${result.wineBottles > 1 ? "s" : ""}`);
      line("Beer", `${result.beerUnits} x 12oz bottles/cans`);

      y += 14;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(120, 108, 94);
      doc.text("Assumes 2 drinks per guest per active hour — half the volume to spirits, the rest split between beer (60%)", 48, y);
      doc.text("and wine (40%). One 750ml spirit bottle yields ~16 cocktails; a wine bottle pours 5 glasses.", 48, y + 14);
      doc.text("You buy the bottles — Pop Social handles mixers, juices, syrups, garnishes, ice, and the craft.", 48, y + 34);

      const footY = doc.internal.pageSize.getHeight() - 64;
      doc.setDrawColor(212, 155, 75);
      doc.line(48, footY - 22, W - 48, footY - 22);
      doc.setFontSize(9);
      doc.setTextColor(140, 126, 110);
      doc.text("Pop Social Events  ·  www.popsocialevents.com  ·  carlos@popsocialevents.com  ·  Miami · Broward · Palm Beach", W / 2, footY, { align: "center" });
      doc.save("pop-social-shopping-list.pdf");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button type="button" className="text-button shopping-list-button" onClick={download} disabled={busy || !result.spiritBottles.length} data-testid="calculator-download-list-button" title={result.spiritBottles.length ? "Download your shopping list as a PDF" : "Select at least one spirit first"}>
      {busy ? <LoaderCircle className="spin" size={14} /> : <FileDown size={14} />} Download shopping list (PDF)
    </button>
  );
};
